import styled from "@emotion/styled";
import { useState } from "react";
import { InputLabel, MenuItem, Switch } from "@kaltura/ds-react-components";
import { booleanProp, kmsCookie, translate } from "@kaltura/mediaspace-shared-utils";

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    // override eventsplatform css
    ".eventsplatform &": {
        color: "inherit",
        [`&:hover`]: {
            color: "inherit",
        },
    },
    // override bootstrap css
    "input[type='checkbox']": {
        margin: 0,
        cursor: "inherit",
    },
    "& > div": {
        paddingTop: 5,
    },
}));

const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
    display: "inline-block",
    lineHeight: "24px",
    marginBottom: 0,
    minWidth: 120,
}));

const StyledSwitch = styled(Switch)(({ theme }) => ({
    float: "right",
    // override bootstrap css
    span: {
        boxSizing: "inherit",
    },
}));

/**
 * High Contrast Menu Item for the user menu
 */
export const HighContrastMenuItem = (props: { title: string; autoFocus?: boolean }) => {
    const { title, autoFocus = true } = props;
    const [checked, setChecked] = useState(() => booleanProp(kmsCookie("kms-contrast") as string));

    const handleKeyDown = (event?: React.KeyboardEvent<HTMLLIElement>) => {
        switch (event?.key) {
            case " ":
                handleChecked(!checked);
                break;
        }
    };

    const handleChecked = (checked: boolean) => {
        setChecked(checked);

        const date = new Date();
        // set cookie for 10 years
        date.setTime(date.getTime() + 10 * 365 * 24 * 60 * 60 * 1000);

        const options = {
            expires: date,
            path: "/",
        };

        // set cookie
        kmsCookie("kms-contrast", checked ? "true" : null, options);

        // fire custom event - used by theme provider to set the high contrast prop
        const event = new CustomEvent("kms-contrast", {});
        document.dispatchEvent(event);
    };

    return (
        <StyledMenuItem
            autoFocus={autoFocus}
            onKeyDown={handleKeyDown}
            aria-label={translate("High Contrast Switch is %1", [checked ? translate("On") : translate("Off")])}
            aria-live="polite"
        >
            <StyledInputLabel>{title}</StyledInputLabel>
            <StyledSwitch
                checked={checked}
                onChange={(event, checked) => {
                    handleChecked(checked);
                }}
                inputProps={{
                    role: "switch",
                    "aria-checked": checked,
                }}
            />
        </StyledMenuItem>
    );
};
export default HighContrastMenuItem;
